<template>
  <default-layout :breadcrumbs="breadcrumbs">
    <h1 style="display: none">Pasang Iklan Primary</h1>
    <packages />
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import Packages from '@/components/static-page/packages';
import HelperMixin from '@/mixins/helpers';
import tawkto from '@/mixins/tawkto.js';

export default {
  name: 'packages-page',
  mixins: [HelperMixin, tawkto],
  components: {
    DefaultLayout,
    Packages,
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: this.$t('general.homepage'),
          to: '/',
        },
        {
          text: this.$t('packages.title'),
          to: this.$router.currentRoute.path,
        },
      ];
    },
  },
  async fetch({ store, route }) {
    const baseUrl = store.state.global.baseUrl;
    const title = 'BeliRumah.co - Pasang Iklan Primary';
    const description =
      'Dapatkan leads, kelola listing, dan optimalkan pemasaran dengan fitur lengkap serta konten promosi menarik. Gunakan sekarang!';
    const head = {
      title: title,
      meta: [
        { hid: 'og-url', property: 'og:url', content: baseUrl + route.fullPath },
        { hid: 'og-type', property: 'og:type', content: 'article' },
        {
          hid: 'og-title',
          property: 'og:title',
          content: title,
        },
        {
          hid: 'og-description',
          property: 'og:description',
          content: description,
        },
        { hid: 'og-site-name', property: 'og:site_name', content: 'BeliRumah' },
        { hid: 'og-image-width', property: 'og:image:width', content: '450' },
        { hid: 'og-image-height', property: 'og:image:height', content: '450' },
        { hid: 'og-fb-app_id', property: 'fb:app_id', content: '2017706101791817' },
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: baseUrl + route.fullPath,
          id: 'canonical',
        },
      ],
    };
    store.commit('head/SET_CONTENT', head);
  },
};
</script>
